export const ENTRY_SOURCE_QUERY_KEY = 'entrySource';

export const SHORTS_ENTRY_SOURCE = {
	CLUSTER: 'cluster',
	/** Sessão aberta a partir das captações exclusivas do perfil do corretor. */
	AGENT_PROFILE: 'agent-profile'
} as const;

export type ShortsEntrySource =
	(typeof SHORTS_ENTRY_SOURCE)[keyof typeof SHORTS_ENTRY_SOURCE];

export const PDP_ENTRY_SOURCE = {
	SHORTS: 'shorts'
} as const;

export type PdpEntrySource =
	(typeof PDP_ENTRY_SOURCE)[keyof typeof PDP_ENTRY_SOURCE];

export type EntrySource = ShortsEntrySource | PdpEntrySource;

export function withEntrySource(
	query: Record<string, string>,
	entrySource?: EntrySource
): Record<string, string> {
	if (!entrySource) return query;

	return {
		...query,
		[ENTRY_SOURCE_QUERY_KEY]: entrySource
	};
}

export function isEntrySource(
	query: Record<string, unknown>,
	entrySource: EntrySource
): boolean {
	const value = query[ENTRY_SOURCE_QUERY_KEY];
	return Array.isArray(value)
		? value[0] === entrySource
		: value === entrySource;
}
